import { useQuery } from "@tanstack/react-query";
import { getConversions } from "../../../../../../../../../shared/api/catalogs";

interface GetConversionActionsParams {
	app_id: string;
	buyer_id: number;
	customer_id: string;
}

export const fetchConversionActions = async (
	params: GetConversionActionsParams,
) => {
	const data = await getConversions(params);
	return data;
};
